import { render, staticRenderFns } from "./head_navigation.vue?vue&type=template&id=ffbb1c78&scoped=true"
import script from "./head_navigation.vue?vue&type=script&lang=js"
export * from "./head_navigation.vue?vue&type=script&lang=js"
import style0 from "./head_navigation.vue?vue&type=style&index=0&id=ffbb1c78&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ffbb1c78",
  null
  
)

export default component.exports